export const locale = {
    lang: 'es',
    data: {
        HELPER: {
            TIME: {
                FORMAT_DATE_WITH_HOUR: 'dd/MM/yyyy HH:mm',
                FORMAT_SECOND: 'hace {{ seconds }} segundo',
                FORMAT_SECONDS: 'hace {{ seconds }} segundos',
                FORMAT_MINUTE: 'hace {{ minutes }} minuto',
                FORMAT_MINUTES: 'hace {{ minutes }} minutos',
                FORMAT_HOUR: 'hace {{ hours }} hora',
                FORMAT_HOURS: 'hace {{ hours }} horas',
            },
            LABEL: {
                DELIVERY_ROUTE_PERIOD: {
                    MORNING: 'Mañana',
                    AFTERNOON: 'Tarde',
                },
                PEOPLE_TYPE: {
                    CUSTOMER: 'Cliente',
                    EMPLOYEE: 'Empleado',
                    SUPPLIER: 'Proveedor',
                },
                LABEL_TYPE: {
                    BROTHER_62_30: 'Brother 62x30 mm',
                    PIMACO_28_51: 'Pimaco 28x51 mm (SLP-MRL)',
                    PIMACO_28_89: 'Pimaco 28x89 mm (SLP-2RLH)',
                    PIMACO_36_89: 'Pimaco 36x89 mm (SLP-2RLE)',
                    PIMACO_54_101: 'Pimaco 54x101 mm (SLP-SRL)',
                    ZEBRA_80_50: 'Zebra 80x50 mm',
                    ZEBRA_50_30: 'Zebra 50x30 mm',
                    ZEBRA_50_30_X2: 'Zebra 50x30 mm - 2 columnas',
                },
                LABEL_IDENTIFICATION_CODE: {
                    QR_CODE: 'Código QR',
                    BAR_CODE: 'Código de barras',
                },
                LABEL_IDENTIFICATION_TYPE: {
                    ORDER: 'Datos del pedido',
                    ADDRESS: 'Dirección',
                    ITEMS: 'Ítems',
                },
                OUTSOURCE_STATUS: {
                    PENDING: 'Enviado',
                    FINISH: 'Finalizado',
                    DELAYED: 'Atrasado',
                },
                EQUIPMENT_TYPE: {
                    SCANNER: 'Escáner',
                    MILLING: 'Fresadora',
                    PRINTER: 'Impresora',
                    FURNACE: 'Furnace',
                    OTHER: 'Otro',
                },
                ORDER_ITEM_TYPES: {
                    PRODUCT: 'Producto',
                    SERVICE: 'Servicio',
                },
                COMMISSION_INCLUDE_TYPE: {
                    ORDER: 'Pedidos finalizados',
                    STAGE: 'Etapas finalizadas',
                },
                COMMISSION_CALC_BASIS: {
                    GROSS_VALUE: 'Valor bruto del servicio',
                    NET_VALUE: 'Valor neto del servicio',
                },
                CUSTOMER_STATUS: {
                    ACTIVE: {
                        ACTIVE: 'Activo',
                        TEMPORARY: 'Temporalmente activo',
                    },
                    LEAD: 'Oportunidad',
                    INACTIVE: 'Inactivo',
                    BLOCKED: 'Bloqueado',
                },
                DENTISTRY_DENTAL_NOTATION: {
                    FDI_NOTATION: 'Anotaciones sistema FDI',
                    UNIVERSAL_SYSTEM: 'Sistema universal',
                    PALMER_NOTATION: 'Anotaciones sistema Palmer',
                },
                INVOICE_TYPE: {
                    BIWEEKLY: 'Quincenal',
                    MONTHLY: 'Mensual',
                },
                REGISTRATION_TYPE: {
                    PERSONAL: 'Persona Física',
                    BUSINESS: 'Persona Jurídica',
                },
                PHONE_TYPES: {
                    HOME: 'Casa',
                    MOBILE: 'Móvil',
                    WORK: 'Trabajo',
                    OTHER: 'Otro',
                },
                EMPLOYEE_STATUS: {
                    ACTIVE: 'Activo',
                    INACTIVE: 'Inactivo',
                },
                KIWID_PLAN_SOFTWARE_LEVEL: {
                    PRO: 'Pro',
                    BASIC: 'Basic',
                    ESSENTIAL: 'Essential',
                },
                SUPPLIER_STATUS: {
                    ACTIVE: 'Activo',
                    INACTIVE: 'Inactivo',
                },
                SUPPLIER_TYPES: {
                    BUSINESS: 'Jurídica',
                    NATURAL: 'Física',
                },
                PAYMENT_METHOD: {
                    CASH: 'Efectivo',
                    CHECK: 'Cheque',
                    ACCOUNT_CREDIT: 'Crédito en cuenta',
                    BANK_SLIP: 'Recibo',
                    CREDIT_CARD: 'Tarjeta de crédito',
                    DEBIT_CARD: 'Tarjeta de débito',
                    ONLINE_CARD: 'Tarjeta de crédito online',
                    ONLINE_BANK_SLIP: 'Recibo online',
                    TRANSFER: 'Transferencia',
                    DIRECT_DEBIT: 'Débito directo',
                    ACCOUNT_TRANSFER: 'Transferencia de cuentas',
                    PIX: 'Pix',
                    NONE: '-',
                },
                ORDER_STATUS: {
                    DRAFT: 'Borrador',
                    NEW: 'Nuevo',
                    APPROVAL: 'Aprobación',
                    PENDING: 'Pendiente',
                    PRODUCTION: 'Producción',
                    PROOF: 'Prueba',
                    DELAYED: 'Atrasado',
                    FINISHED: 'Finalizado',
                    DELIVERED: 'Entregado',
                    CANCELLED: 'Cancelado',
                    SUSPENDED: 'Suspenso',
                },
                PRODUCTION_STATUS: {
                    PENDING: 'Pendiente',
                    ACTIVE: 'Activo',
                    FINISHED: 'Finalizado',
                    CANCELED: 'Cancelado',
                },
                GENDER: {
                    MALE: 'Masculino',
                    FEMALE: 'Femenino',
                    NOT_BINARY: 'No binario',
                },
                ORDER_TYPE: {
                    ORDER: 'Pedido',
                    QUOTATION: 'Presupuesto',
                },
                PHONE: {
                    HOME: 'Casa',
                    MOBILE: 'Movil',
                    WORK: 'Trabajo',
                    OTHER: 'Otros',
                },
                INVOICE_STATUS: {
                    OPEN: 'En abierto',
                    CLOSED: 'Cerrado',
                    PAID: 'Pagado',
                    CANCELLED: 'Cancelado',
                },
                RECEIVABLE_STATUS: {
                    PENDING: 'Pendiente',
                    CANCELLED: 'Cancelado',
                    PAID: 'Pagado',
                    REFUSED: 'Rechazado',
                    REFUNDED: 'Reembolsado',
                    DISPUTE: 'En disputa',
                    CHARGEBACK: 'Cargo de vuelta',
                },
                RECEIVABLE_TOOLTIP_STATUS: {
                    PENDING: 'Transacción pendiente',
                    OVERDUE: 'Transacción vencida',
                    DUE_DATE_TODAY: 'Transacción vence hoy',
                    CANCELLED: 'Transacción cancelada',
                    PAID: 'Transacción pagada',
                    REFUSED: 'Transacción rechazada',
                    REFUNDED: 'Transacción devuelta',
                    DISPUTE: 'Transacción en disputa de cargo de vuelta',
                    CHARGEBACK: 'Transacción con cargo de vuelta',
                },
                CREDIT_CARD_BRAND: {
                    VISA: 'Visa',
                    MASTERCARD: 'Mastercard',
                    AMERICAN_EXPRESS: 'American express',
                    ELO: 'Elo',
                    HIPERCARD: 'hipercard',
                    HIPER: 'Hiper',
                    DISCOVER: 'Discover',
                    DINERS: 'Diners',
                    AURA: 'Aura',
                    JCB: 'Jcb',
                    CABAL: 'Cabal',
                    BANESCARD: 'Banescard',
                },
                TRANSFER_INTERVAL: {
                    DAILY: 'Diario',
                    WEEKLY: 'Semanal',
                    MONTHLY: 'Mensual',
                },
                LOCATION_STATUS: {
                    TRIAL_EXPIRES: 'EL PERIORO DE PRUEBA EXPIRA EN {{ days }} DIAS. ADQUIÉRALO!',
                    TRIAL_EXPIRES_ONE_DAY: 'EL PERIORO DE PRUEBA EXPIRA EN {{ days }} DIA. ADQUIERALO!',
                    LOCATION_TRIAL_EXPIRES: '{{ locationName }}: EL PERIORO DE PRUEBA EXPIRA EN {{ days }} DIAS. ADQUIERALO!',
                    LOCATION_TRIAL_EXPIRES_ONE_DAY: '{{ locationName }}: EL PERIORO DE PRUEBA EXPIRA EN{{ days }} DIA. ADQUIERALO!',
                    DEBTOR: 'SU PAGO ESTÁ ATRASADO. VERIFIQUELO!',
                    LOCATION_DEBTOR: '{{ locationName }}: SU PAGO ESTÁ ATRSADADO. VERIFIQUELO!',
                    TRIAL_ENDED: 'SU PERIODO DE PRUEBA TERMINÓ. ADQUIERALO!',
                    LOCATION_TRIAL_ENDED: '{{ locationName }}: SU PERIODO DE PRUEBA TERMINÓ. ADQUIERALO!',
                },
                STOCK_KEY: {
                    NEW_STOCK: 'Nuevo stock',
                    RETURN: 'Regreso',
                    TRANSFER: 'Transferencia',
                    INTERNAL_USE: 'Uso interno',
                    DAMAGED: 'Dañado',
                    OUT_OF_DATE: 'Vencido',
                    ADJUSTMENT: 'Ajuste',
                    LOST: 'Pérdida',
                    REMAKE: 'Repetición',
                    OTHER: 'Otro',
                    STOCK_ENABLED: 'Monitoreo de inventario habilitado',
                    STOCK_DISABLED: 'Monitoreo de inventario deshabilitado',
                    SALE: 'Pedido ',
                    ORDER_REOPEN: 'Reabierta pedido ',
                    ORDER_CANCELLED: 'Cancelado pedido ',
                    ORDER_DELETED: 'Eliminado pedido ',
                    ITEM_DELETED: 'Eliminado item de pedido ',
                    INVENTORY_ORDER_CANCELLED: 'Cancelado compra ',
                    INVENTORY_ORDER_DELETED: 'Eliminado compra ',
                },
                DELIVERY_ROUTE_STATUS: {
                    PENDING: 'Programado',
                    SCHEDULED: 'Liberado',
                    FINISHED: 'Entregado',
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Pago en efectivo',
                        CHECK: 'Pago con cheque',
                        ACCOUNT_CREDIT: 'Pago con crédito en cuenta',
                        BANK_SLIP: 'Pago con boleto bancario',
                        CREDIT_CARD: 'Pago con tarjeta de crédito',
                        CREDIT_CARD_FREQUENCY: 'Pago a plazos con tarjeta de crédito',
                        DEBIT_CARD: 'Pago con tarjeta de débito',
                        ONLINE_CARD: 'Pago con tarjeta de crédito online',
                        ONLINE_BANK_SLIP: 'Pago con boleto bancario online',
                        CANCEL: {
                            BANK_SLIP: 'Cancelación de boleto bancario',
                            CHECK: 'Cancelación de cheque',
                            CASH: 'Cancelación de efectivo',
                            ACCOUNT_CREDIT: 'Cancelación de crédito en cuenta',
                            CREDIT_CARD: 'Cancelación de tarjeta de crédito',
                            DEBIT_CARD: 'Cancelación de tarjeta de débito',
                            ONLINE_CARD: 'Cancelación de tarjeta de crédito online',
                            ONLINE_BANK_SLIP: 'Cancelación de boleto bancario online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Reembolso de tarjeta online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Charged back de tarjeta online',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Pago parcelado',
                        CASH: 'Pago parcelado en efectivo',
                        CHECK: 'Pago parcelado en cheque',
                        ACCOUNT_CREDIT: 'Pago parcelado con crédito en cuenta',
                        BANK_SLIP: 'Pago parcelado en boleto bancario',
                        CREDIT_CARD: 'Pago parcelado con tarjeta de crédito',
                        DEBIT_CARD: 'Pago parcelado con tarjeta de débito',
                        ONLINE_CARD: 'Pago parcelado con tarjeta de crédito online',
                        ONLINE_BANK_SLIP: 'Pago parcelado en boleto bancario online',
                        CANCEL: {
                            BANK_SLIP: 'Cuota de boleto bancario cancelada',
                            CHECK: 'Cuota de cheque cancelada',
                            CASH: 'Cuota de efectivo cancelada',
                            ACCOUNT_CREDIT: 'Cuota de crédito en cuenta cancelada',
                            CREDIT_CARD: 'Cuota de tarjeta de crédito cancelada',
                            DEBIT_CARD: 'Cuota de tarjeta de débito cancelada',
                            ONLINE_CARD: 'Cuota de tarjeta de crédito online cancelada',
                            ONLINE_BANK_SLIP: 'Cuota de boleto bancario online cancelada',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Cuota estornada de tarjeta de crédito online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Cuota charged back de tarjeta de crédito online',
                        },
                    },
                },
                KEY_MOVEMENTS: {
                    OTHER: 'Otros',
                    DISCOUNT: 'Descuento',
                    REFUND: 'Reembolso',
                    ORDER: 'Orden',
                    PAYMENT: 'Pago',
                    INITIAL_BALANCE: 'Saldo inicial',
                },
                MEDIA_TYPE: {
                    PRIVATE: 'Privado',
                    PUBLIC: 'Público',
                },
                ACCOUNT_BANK: {
                    CHECKING_ACCOUNT: 'Cuenta corriente',
                    SAVINGS_ACCOUNT: 'Cuenta de ahorro',
                    CASH_ACCOUNT: 'Cuenta interna',
                    CREDIT_CARD_ACCOUNT: 'Tarjeta de crédito',
                    DIGITAL_ACCOUNT: 'Cuenta digital',
                },
                PIX_KEY: {
                    DOCUMENT: 'Documento',
                    PHONE: 'Teléfono',
                    EMAIL: 'E-mail',
                    RANDOM: 'Aleatoria',
                },
                MOVEMENT_PAYMENT_DESCRIPTION: {
                    PAYMENT: 'Pago',
                    REFUND_PAYMENT: 'Pago de reembolso',
                    CANCEL: 'Cancelado',
                    GENERATE: 'Generado',
                    PAYMENT_CASH: 'Pago en efectivo',
                    PAYMENT_INSTALLMENT: 'Pago {{ installment }}x',
                    PAYMENT_INSTALLMENT_DESCRIPTION: {
                        DEFAULT: 'Pago en {{ installment }}x',
                        CANCELLED: 'Cancelado: Pago de la cuota {{ installmentNumber }}',
                    },
                    REFUND: 'Estorno',
                },
                MOVEMENT_PAYMENT_SUB_DESCRIPTION: {
                    DATE_FORMAT: 'dd/MM/yyyy',
                    ACCOUNT_NAME: 'Cuenta: {{ accountName }}',
                    NF_NAME: 'FA: {{ nfName }}',
                    DUE_DATE: 'Vencimiento: {{ dueDate }}',
                    CHECK: {
                        NUMBER: 'Número',
                        NAME: 'Nombre',
                        DATE: 'Fecha',
                    },
                },
                RELATIVE_TYPES: {
                    PARTNER: 'Cónyuge',
                    FATHER: 'Padre',
                    MOTHER: 'Madre',
                    BROTHER_SISTER: 'Hermana(o)',
                    SON_DAUGHTER: 'Hija(o)',
                    FRIEND: 'Amigo',
                    OTHER: 'Otro',
                },
                INVENTORY_ORDER_STATUS: {
                    DRAFT: 'Borrador',
                    APPROVAL: 'En aprobación',
                    ORDERED: 'Solicitado',
                    PARTIAL: 'Parcial',
                    RECEIVED: 'Recibido',
                    CANCELLED: 'Cancelado',
                },
                LAMBDA: {
                    REPORT_ORDER_EQUIPMENT_DETAIL: 'Equipos',
                    REPORT_ORDER_EQUIPMENT_BY_EQUIPMENT: 'Equipos',
                    REPORT_ORDER_EQUIPMENT_BY_STAGE: 'Equipos',
                    REPORT_ORDER_DETAILED: 'Pedidos detallados',
                    REPORT_ORDER_FINISHED: 'Pedidos finalizados',
                    REPORT_ORDER_PENDING: 'Pedidos pendientes',
                    REPORT_FINANCIAL_PAYMENT_LINK: 'Link de pago',
                    REPORT_FINANCIAL_DEBIT_CREDIT_BALANCE: 'Deudores / Acreedores',
                    REPORT_FINANCIAL_RECEIPT: 'Recibos emitidos',
                    REPORT_ORDER_OUTSOURCE: 'Subcontratados',
                    REPORT_ORDER_RATING: 'Calificaciones de pedidos',
                    REPORT_SERVICE_PRODUCTION_BY_MONTH: 'Producción de servicio por mes',
                    REPORT_EMPLOYEE_PRODUCTION_SCHEDULE: 'Agenda de producción de empleados',
                    REPORT_SERVICE_STAGE: 'Servicios y Trámites',
                    APP_PRICE_TABLE: 'Lista de precio',
                    APP_PRODUCTION_SCHEDULE: 'Agenda de producción',
                    REPORT_FINANCIAL_REVENUE: 'Pagos',
                    REPORT_INVENTORY_ORDER_DETAIL: 'Compras detalladas',
                    REPORT_INVENTORY_ORDER_PRODUCT: 'Compras por productos',
                    REPORT_INVENTORY_ORDER_SUPPLIER: 'Compras por proveedores',
                    REPORT_INVENTORY_ORDER_PERIOD: 'Compras por período',
                },
            },
            PDF: {
                DATE_FORMAT: 'dd/MM/yyyy',
                DATETIME_FORMAT: 'dd/MM/yyyy HH:mm:ss',
                USER: 'Usuario',
                RECEIVABLES: {
                    ACCOUNT: 'Cuenta bancaria',
                    EXPENSE: 'Gastos',
                    INCOME: 'Pagos',
                    RECURRENT: 'Recurrente',
                    TABLE: {
                        THEAD: {
                            DATE: 'Fecha',
                            PEOPLE_INCOME: 'Recibido de',
                            PEOPLE_EXPENSE: 'Pagado a',
                            DESCRIPTION: 'Descripción',
                            EXTERNAL_INVOICE_NUMBER: 'Nº factura externa',
                            GROSS_VALUE: 'Valor bruto',
                            NET_VALUE: 'Valor neto',
                            DUE_DATE: 'Fecha de vencimiento',
                            PAYMENT_METHOD_EXPENSE: 'Forma de gastos',
                            PAYMENT_METHOD_INCOME: 'Forma de pagos',
                            STATUS: 'Estado',
                        },
                        TBODY: {
                            ACCRUAL_DATE: 'Comp.: {{date}}',
                        },
                    },
                    RESUME_TOTAL: {
                        GROSS_VALUE: 'Valor bruto',
                        TAX: 'Impuestos',
                        RATE: 'Tasa de interés',
                        DISCOUNT: 'Descuentos',
                        NET_VALUE: 'Valor neto',
                        PAID_INCOME: 'Total pagado',
                        UNPAID_INCOME: 'Total por cobrar',
                        PAID_EXPENSE: 'Total pagado',
                        UNPAID_EXPENSE: 'Total por pagar',
                    },
                },
                PAYMENT_DESCRIPTION: {
                    PAYMENT: {
                        CASH: 'Pago en efectivo',
                        CHECK: 'Pago con cheque',
                        ACCOUNT_CREDIT: 'Pago con crédito en cuenta',
                        BANK_SLIP: 'Pago con boleto',
                        CREDIT_CARD: 'Pago con tarjeta de crédito',
                        CREDIT_CARD_FREQUENCY: 'Pago con tarjeta de crédito a plazos',
                        DEBIT_CARD: 'Pago con tarjeta de débito',
                        ONLINE_CARD: 'Pago con tarjeta de crédito online',
                        ONLINE_BANK_SLIP: 'Pago con boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Cancelación de boleto',
                            CHECK: 'Cancelación de cheque',
                            CASH: 'Cancelación de efectivo',
                            ACCOUNT_CREDIT: 'Cancelación de crédito en cuenta',
                            CREDIT_CARD: 'Cancelación de tarjeta de crédito',
                            DEBIT_CARD: 'Cancelación de tarjeta de débito',
                            ONLINE_CARD: 'Cancelación de tarjeta de crédito online',
                            ONLINE_BANK_SLIP: 'Cancelación de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Reembolso de tarjeta online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Charged back de tarjeta online',
                        },
                    },
                    INSTALLMENT: {
                        EMPTY: 'Pago a plazos',
                        // EMPTY_COUNT: 'Pagamento parcelado em {{installmentTotal}}x',
                        CASH: 'Pago a plazos en efectivo',
                        CHECK: 'Pago a plazos con cheque',
                        ACCOUNT_CREDIT: 'Pago a plazos con crédito en cuenta',
                        BANK_SLIP: 'Pago a plazos con boleto',
                        CREDIT_CARD: 'Pago a plazos con tarjeta de crédito',
                        DEBIT_CARD: 'Pago a plazos con tarjeta de débito',
                        ONLINE_CARD: 'Pago a plazos con tarjeta de crédito online',
                        ONLINE_BANK_SLIP: 'Pago a plazos con boleto online',
                        CANCEL: {
                            BANK_SLIP: 'Cuota cancelada de boleto',
                            CHECK: 'Cuota cancelada de cheque',
                            CASH: 'Cuota cancelada de efectivo',
                            ACCOUNT_CREDIT: 'Cuota cancelada de crédito en cuenta',
                            CREDIT_CARD: 'Cuota cancelada de tarjeta de crédito',
                            DEBIT_CARD: 'Cuota cancelada de tarjeta de débito',
                            ONLINE_CARD: 'Cuota cancelada de tarjeta de crédito online',
                            ONLINE_BANK_SLIP: 'Cuota cancelada de boleto online',
                        },
                        REFUND: {
                            ONLINE_CARD: 'Cuota reembolsada de tarjeta de crédito online',
                        },
                        CHARGED_BACK: {
                            ONLINE_CARD: 'Cuota cobrada revertida de tarjeta de crédito online',
                        },
                    },
                },
            },
            ERROR_INTERCEPTOR: {
                SYSTEM_ERROR: {
                    CONFIRM: {
                        BUTTONS: {
                            CONFIRM: 'Confirmar',
                            CANCEL: 'Cancelar',
                        },
                    },
                    WARNING: {
                        BUTTONS: {
                            CONFIRM: 'Entendido',
                        },
                    },
                },
            },
        },
    },
};
